import styled from 'styled-components';
import colors from 'constants/colors';

export const ClientInfoModalContainer = styled.div`
  display: ${(props) => (props.open? null : 'none')};
  width: 386px;
  height: 100%;
  position: fixed;
  top: 150px;
  right: 0;
  background-color: ${colors.black1};
  z-index: 300;
  padding: 15px 15px;
  border-left: 1px solid ${colors.white};

  .closeButton {
    width: 20px;
    height: 20px;
    margin-bottom: 20px;
    cursor: pointer;
  }

  .clientButtonSection {
    width: 375px;
    margin-bottom: 20px;
    .clientName {
      color: ${colors.white};
      font-size: 17px;
      font-weight: bold;
      margin-bottom: 10px;
    }
    .buttonsContainer {
      display: flex;
      justify-content: flex-start;
      align-items: center;
    }
  }

  .clientInfoItem {
    width: 95%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 14px;
    font-weight: 600;
    margin-bottom: 10px;

    .infoTitle {
      color: ${colors.grey};
    }

    .info {
      color: ${colors.white};
    }
  }
`;